

import React, { lazy, Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import { Path } from "./routes";
import ProtectedRoute from "../store/ProtectedRoute";
import AdminProtectedRoute from "../store/AdminProtectedRoute";
import DashboardLayout from "../components/UserLayout";
//import ProtectedRoute from "../store/ProtectedRoute";

import WaitingList from "../pages/admin/waiting_list";

const NotFound = lazy(() => import("../pages/404"));
const DashboardNotFound = lazy(
    () => import("../components/dashboard/DashboardNotFound")
);
const Home = lazy(() => import("../pages/home"));
const Landing = lazy(() => import("../pages/landing"));
const AcceptAssignment = lazy(() => import("../pages/user/secure"));

const DealRoom = lazy(() => import("../pages/user/dealroom"));
const DealRoomDetail = lazy(() => import("../pages/user/dealroom/Detail"));
const Landlord = lazy(() => import("../pages/landing/LandlordLanding"));
const Lawyer = lazy(() => import("../pages/landing/Lawyer"));
const Agent = lazy(() => import("../pages/landing/AgentLanding"));
const Customer = lazy(() => import("../pages/landing/CustomerLanding"));
const Realtor = lazy(() => import("../pages/landing/RealtorLanding"));
const Team = lazy(() => import("../pages/landing/Team"));
//const Property = lazy(() => import("../pages/landing/Property/Property"));
const Property = lazy(() => import("../pages/landing/property"));
const PropertyDetail = lazy(() => import("../pages/landing/property/PropertyDetail"));
const AgentProfile = lazy(() => import("../pages/landing/AgentProfilePage"));

const About = lazy(() => import("../pages/about"));
const ContactUs = lazy(() => import("../pages/contact"));

const Login = lazy(() => import("../pages/login"));
const Signup = lazy(() => import("../pages/signup"));
const BuyerSignup = lazy(() => import("../pages/buyer"));
const Otp = lazy(() => import("../pages/signup/OTP"));
const ForgotPassword = lazy(() => import("../pages/forgotpassword"));
const ResetPassword = lazy(() => import("../pages/resetpassword"));


const AdminLogin = lazy(() => import("../pages/adminlogin"));
const AdminDashboard = lazy(() => import("../pages/admin/dashboard"));
const AdminProperty = lazy(() => import("../pages/admin/property"));
const AdminUsers = lazy(() => import("../pages/admin/users"));
const AdminKycStatus = lazy(() => import("../pages/admin/kyc_status"));
const AdminSetting = lazy(() => import("../pages/admin/setting"));
const AdminPropertyDetail = lazy(() => import("../pages/admin/property/PropertyDetails"));

const AdminDealRoom = lazy(() => import("../pages/admin/deal_room"));
const AdminDealRoomDetail = lazy(() => import("../pages/admin/deal_room/Detail"));
const AdminBookings = lazy(() => import("../pages/admin/bookings"));
const AdminNotifications = lazy(() => import("../pages/admin/notifications"));
const AdminNotFound = lazy(() => import("../components/dashboard/AdminNotFound"));

const UserDashboard = lazy(() => import("../pages/user/dashboard"));
const UserKyc = lazy(() => import("../pages/user/kyc"));
//const UserProperty = lazy(() => import("../pages/user/property"));
const UserProperty = lazy(() => import("../pages/user/property/PropertyList"));
const UserAddProperty = lazy(() => import("../pages/user/property/AddProperty"));
const UserPropertyDetail = lazy(() => import("../pages/user/property/PropertyDetails"));
const UserMessage = lazy(() => import("../pages/user/message"));
const UserSetting = lazy(() => import("../pages/user/setting"));
const UserEditProperty = lazy(() => import("../pages/user/property/EditPropertyPage"));

const LandlordMyPropertyBooking = lazy(() => import("../pages/user/property/MyPropertyBookings"));
const UserAgencyAgreement = lazy(() => import("../pages/user/property/AgencyAgreementsPage"));

const LandlordTenancy = lazy(() => import("../pages/user/landlord/tenancy/TenanciesPage"));
const LandlordJourney = lazy(() => import("../pages/user/landlord/LandlordJourneyPage"));
const LandlordRentReceipt = lazy(() => import("../pages/user/landlord/tenancy/RentReceiptsPage"));
const LandlordRentReminder = lazy(() => import("../pages/user/landlord/tenancy/RentRemindersPage"));
const LandlordRentWallet = lazy(() => import("../pages/user/landlord/tenancy/RentWalletsPage"));
const LandlordRentDeposit = lazy(() => import("../pages/user/landlord/tenancy/RentDepositsPage"));
const LandlordNotice = lazy(() => import("../pages/user/landlord/tenancy/NoticePage"));
const LandlordTransactionOffer = lazy(() => import("../pages/user/landlord/transaction/OffersNegotiationsPage"));
const LandlordTransactionLois = lazy(() => import("../pages/user/landlord/transaction/LoisPage"));
const LandlordTransactionDealRoom = lazy(() => import("../pages/user/landlord/transaction/DealRoomsPage"));
const LandlordTransactionContracts = lazy(() => import("../pages/user/landlord/transaction/ContractsDeedsPage"));
const LandlordEnquiries = lazy(() => import("../pages/user/landlord/EnquiriesPage"));

// BUYER

const BuyerJourney = lazy(() => import("../pages/user/buyer/BuyerJourneyPage"));
const BuyerDiscoverProperties = lazy(() => import("../pages/user/buyer/DiscoverPropertiesPage"));
const BuyerBookingsViewings = lazy(() => import("../pages/user/buyer/BookingsViewingsPage"));
const BuyerInspections = lazy(() => import("../pages/user/buyer/InspectionsPage"));
const BuyerMyEnquiries = lazy(() => import("../pages/user/buyer/MyEnquiriesPage"));
const BuyerDueDiligence = lazy(() => import("../pages/user/buyer/DueDiligencePage"));
const BuyerMyOffers = lazy(() => import("../pages/user/buyer/MyOffersPage"));
const BuyerLois = lazy(() => import("../pages/user/buyer/LoisPage"));
const BuyerTransactionDealRoom = lazy(() => import("../pages/user/buyer/DealRoomsPage"));
const BuyerTransactionContracts = lazy(() => import("../pages/user/buyer/ContractsDeedsPage"));


// TENANTS

const TenantDiscoverProperties = lazy(() => import("../pages/user/tenant/DiscoverPropertiesPage"));
const TenantJourney = lazy(() => import("../pages/user/tenant/TenantJourneyPage"));
const TenantBookingsViewings = lazy(() => import("../pages/user/tenant/BookingsViewingsPage"));
const TenantMyEnquiries = lazy(() => import("../pages/user/tenant/MyEnquiriesPage"));
const Tenancies = lazy(() => import("../pages/user/tenant/MyTenanciesPage"));
const TenantNoticesRenewals = lazy(() => import("../pages/user/tenant/NoticesRenewalsPage"));
const TenantAgreements = lazy(() => import("../pages/user/tenant/AgreementsPage"));
const TenantRentReceipts = lazy(() => import("../pages/user/tenant/RentReceiptsPage"));
const TenantRentWallet = lazy(() => import("../pages/user/tenant/RentWalletPage"));


//AGENTS

const AgentsAvailableListings = lazy(() => import("../pages/user/agent/AvailableListingsPage"));
const AgentJourney = lazy(() => import("../pages/user/agent/AgentJourneyPage"));
const AgentsMyAssignments = lazy(() => import("../pages/user/agent/MyAssignmentsPage"));
const AgentsAgencyAgreements = lazy(() => import("../pages/user/agent/AgencyAgreementsPage"));
const AgentsEnquires = lazy(() => import("../pages/user/agent/EnquiriesPage"));
const AgentsBookingInspections = lazy(() => import("../pages/user/agent/BookingsInspectionsPage"));
const AgentsDealRooms = lazy(() => import("../pages/user/agent/DealRoomsPage"));
//const AgentsDealRoomDetails = lazy(() => import("../pages/user/agent/MyAssignmentsPage"));
const AgentsOffers = lazy(() => import("../pages/user/agent/OffersNegotiationsPage"));
const AgentsCommissions = lazy(() => import("../pages/user/agent/CommissionsPage"));
const AgentsPayout = lazy(() => import("../pages/user/agent/PayoutsPage"));


//LAWYERS

const LawyerEngagement = lazy(() => import("../pages/user/lawyer/EngagementsPage"));
const LawyerJourney = lazy(() => import("../pages/user/lawyer/LawyerJourneyPage"));
const LawyerDealRoom = lazy(() => import("../pages/user/lawyer/DealRoomsPage"));
const LawyerDueDiligence = lazy(() => import("../pages/user/lawyer/DueDiligencePage"));
const LawyerPropertySearch = lazy(() => import("../pages/user/lawyer/PropertySearchesPage"));
const LawyerNegotiations = lazy(() => import("../pages/user/lawyer/NegotiationsPage"));
const LawyerContractsOfSales = lazy(() => import("../pages/user/lawyer/ContractsOfSalePage"));
const LawyerTenancyAgreement = lazy(() => import("../pages/user/lawyer/TenancyAgreementsPage"));
const LawyerDigitalDeeds = lazy(() => import("../pages/user/lawyer/DigitalDeedsPage"));
const LawyerMyDocuments = lazy(() => import("../pages/user/lawyer/MyDocumentsPage"));

//VALUER

const ValuerAssignedValuation = lazy(() => import("../pages/user/valuer/AssignedValuationsPage"));
const ValuerJourney = lazy(() => import("../pages/user/valuer/ValuerJourneyPage"));
const ValuerValuationReports = lazy(() => import("../pages/user/valuer/ValuationReportsPage"));
const ValuerDealRoomDocuments = lazy(() => import("../pages/user/valuer/DealRoomDocumentsPage"));

const RolePropertyDetail = lazy(
    () => import("../pages/user/discovery/PropertyDetailPage")
);





const UserManagementDetails = lazy(() => import("../pages/user/property/UserManagementDetails"));

const UserNotifications = lazy(() => import("../pages/user/notifications"));
//const UserNotificationDetails = lazy(() => import("../pages/user/notifications/NotificationDetails"));






const RouterConfig = () => {

    return (
        <Suspense
        //fallback={<Loader />}
        >
            <Routes>
                <Route path={Path.Landing} element={<Landing />} />

                <Route path={Path.Realtor} element={<Realtor />} />
                <Route path={Path.Landlord} element={<Landlord />} />
                <Route path={Path.Lawyer} element={<Lawyer />} />
                <Route path={Path.Agent} element={<Agent />} />
                <Route path={Path.Customer} element={<Customer />} />
                <Route path={Path.Team} element={<Team />} />

                <Route path={Path.Home} element={<Home />} />
                <Route path={Path.ContactUs} element={<ContactUs />} />
                <Route path={Path.About} element={<About />} />

                <Route path={Path.Login} element={<Login />} />
                <Route path={Path.AdminLogin} element={<AdminLogin />} />
                {/* <Route path={Path.AdminDashboard} element={<AdminDashboard />} />
        <Route path={Path.AdminProperty} element={<AdminProperty />} />
        <Route path={Path.AdminUsers} element={<AdminUsers />} /> */}


                <Route path={Path.Signup} element={<Signup />} />
                <Route path={Path.Buyer} element={<BuyerSignup />} />
                <Route path={Path.Otp} element={<Otp />} />
                <Route path={Path.ForgotPassword} element={<ForgotPassword />} />
                <Route path={Path.ResetPassword} element={<ResetPassword />} />

                {/* <Route path={Path.Property} element={<Property properties={[]} />} /> */}

                <Route path={Path.Property} element={<Property />} />
                <Route path={Path.PropertyDetail} element={<PropertyDetail />} />
                <Route path={Path.AgentProfile} element={<AgentProfile />} />
                <Route path="/accept-assignment" element={<AcceptAssignment />} />

                <Route
                    path={Path.UserDashboard}
                    element={
                        <ProtectedRoute>
                            <UserDashboard />
                        </ProtectedRoute>
                    }
                />

                <Route
                    path={Path.UserKyc}
                    element={
                        <ProtectedRoute>
                            <UserKyc />
                        </ProtectedRoute>
                    }
                />

                <Route
                    path={Path.UserAddProperty}
                    element={
                        <ProtectedRoute>
                            <DashboardLayout>
                                <UserAddProperty />
                            </DashboardLayout>
                        </ProtectedRoute>
                    }
                />

                <Route
                    path={Path.LandlordMyPropertyBooking}
                    element={
                        <ProtectedRoute >
                            <LandlordMyPropertyBooking />
                        </ProtectedRoute>
                    }
                />

                <Route
                    path={Path.UserAgencyAgreement}
                    element={
                        <ProtectedRoute>
                            <UserAgencyAgreement />
                        </ProtectedRoute>
                    }
                />

                <Route
                    path={Path.UserProperty}
                    element={
                        <ProtectedRoute>
                            <UserProperty />
                        </ProtectedRoute>
                    }
                />

                <Route
                    path={Path.UserPropertyDetail}
                    element={
                        <ProtectedRoute>
                            <UserPropertyDetail />
                        </ProtectedRoute>
                    }
                />

                <Route
                    path={Path.UserNotifications}
                    element={
                        <ProtectedRoute>
                            <UserNotifications />
                        </ProtectedRoute>
                    }
                />

                <Route
                    path={Path.UserManagementDetails}
                    element={
                        <ProtectedRoute>
                            <UserManagementDetails />
                        </ProtectedRoute>
                    }
                />

                <Route
                    path={Path.UserPropertyDetail}
                    element={
                        <ProtectedRoute>
                            <UserPropertyDetail />
                        </ProtectedRoute>
                    }
                />

                <Route
                    path={Path.UserEditProperty}
                    element={
                        <ProtectedRoute>
                            <DashboardLayout>
                                <UserEditProperty />
                            </DashboardLayout>
                        </ProtectedRoute>
                    }
                />

                <Route
                    path={Path.UserMessage}
                    element={
                        <ProtectedRoute>
                            <UserMessage />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path={Path.UserDealRoom}
                    element={
                        <ProtectedRoute>
                            <DealRoom />
                        </ProtectedRoute>
                    }
                />

                <Route
                    path={Path.UserDealRoomDetail}
                    element={
                        <ProtectedRoute>
                            <DealRoomDetail />
                        </ProtectedRoute>
                    }
                />

                <Route
                    path={Path.UserSetting}
                    element={
                        <ProtectedRoute>
                            <UserSetting />
                        </ProtectedRoute>
                    }
                />


                {/* LANDLORD */}

                <Route
                    path={Path.LandlordJourney}
                    element={
                        <ProtectedRoute>
                            <LandlordJourney />
                        </ProtectedRoute>
                    }
                />

                <Route
                    path={Path.LandlordTenancy}
                    element={
                        <ProtectedRoute>
                            <LandlordTenancy />
                        </ProtectedRoute>
                    }
                />

                <Route
                    path={Path.LandlordRentReceipt}
                    element={
                        <ProtectedRoute>
                            <LandlordRentReceipt />
                        </ProtectedRoute>
                    }
                />

                <Route
                    path={Path.LandlordRentReminder}
                    element={
                        <ProtectedRoute>
                            <LandlordRentReminder />
                        </ProtectedRoute>
                    }
                />

                <Route
                    path={Path.LandlordRentWallet}
                    element={
                        <ProtectedRoute>
                            <LandlordRentWallet />
                        </ProtectedRoute>
                    }
                />

                <Route
                    path={Path.LandlordRentDeposit}
                    element={
                        <ProtectedRoute>
                            <LandlordRentDeposit />
                        </ProtectedRoute>
                    }
                />

                <Route
                    path={Path.LandlordNotice}
                    element={
                        <ProtectedRoute>
                            <LandlordNotice />
                        </ProtectedRoute>
                    }
                />

                <Route
                    path={Path.LandlordEnquiries}
                    element={
                        <ProtectedRoute>
                            <LandlordEnquiries />
                        </ProtectedRoute>
                    }
                />

                <Route
                    path={Path.LandlordTransactionOffer}
                    element={
                        <ProtectedRoute>
                            <LandlordTransactionOffer />
                        </ProtectedRoute>
                    }
                />


                <Route
                    path={Path.LandlordTransactionLois}
                    element={
                        <ProtectedRoute>
                            <LandlordTransactionLois />
                        </ProtectedRoute>
                    }
                />

                <Route
                    path={Path.LandlordTransactionDealRoom}
                    element={
                        <ProtectedRoute>
                            <LandlordTransactionDealRoom />
                        </ProtectedRoute>
                    }
                />

                <Route
                    path={Path.LandlordTransactionContracts}
                    element={
                        <ProtectedRoute>
                            <LandlordTransactionContracts />
                        </ProtectedRoute>
                    }
                />




                {/* BUYER */}


                <Route
                    path={Path.BuyerJourney}
                    element={
                        <ProtectedRoute>
                            <BuyerJourney />
                        </ProtectedRoute>
                    }
                />

                <Route
                    path={Path.BuyerDiscoverProperties}
                    element={
                        <ProtectedRoute>
                            <BuyerDiscoverProperties />
                        </ProtectedRoute>
                    }
                />

                <Route
                    path={Path.BuyerPropertyDetail}
                    element={
                        <ProtectedRoute>
                            <RolePropertyDetail />
                        </ProtectedRoute>
                    }
                />

                <Route
                    path={Path.BuyerBookingsViewings}
                    element={
                        <ProtectedRoute>
                            <BuyerBookingsViewings />
                        </ProtectedRoute>
                    }
                />

                <Route
                    path={Path.BuyerInspections}
                    element={
                        <ProtectedRoute>
                            <BuyerInspections />
                        </ProtectedRoute>
                    }
                />

                <Route
                    path={Path.BuyerMyEnquiries}
                    element={
                        <ProtectedRoute>
                            <BuyerMyEnquiries />
                        </ProtectedRoute>
                    }
                />


                <Route
                    path={Path.BuyerDueDiligence}
                    element={
                        <ProtectedRoute>
                            <BuyerDueDiligence />
                        </ProtectedRoute>
                    }
                />

                <Route
                    path={Path.BuyerMyOffers}
                    element={
                        <ProtectedRoute>
                            <BuyerMyOffers />
                        </ProtectedRoute>
                    }
                />


                <Route
                    path={Path.BuyerLois}
                    element={
                        <ProtectedRoute>
                            <BuyerLois />
                        </ProtectedRoute>
                    }
                />

                <Route
                    path={Path.BuyerTransactionDealRoom}
                    element={
                        <ProtectedRoute>
                            <BuyerTransactionDealRoom />
                        </ProtectedRoute>
                    }
                />


                <Route
                    path={Path.BuyerTransactionContracts}
                    element={
                        <ProtectedRoute>
                            <BuyerTransactionContracts />
                        </ProtectedRoute>
                    }
                />


                {/* TENANTS */}

                <Route
                    path={Path.TenantJourney}
                    element={
                        <ProtectedRoute>
                            <TenantJourney />
                        </ProtectedRoute>
                    }
                />

                <Route
                    path={Path.TenantDiscoverProperties}
                    element={
                        <ProtectedRoute>
                            <TenantDiscoverProperties />
                        </ProtectedRoute>
                    }
                />

                <Route
                    path={Path.TenantPropertyDetail}
                    element={
                        <ProtectedRoute>
                            <RolePropertyDetail />
                        </ProtectedRoute>
                    }
                />

                <Route
                    path={Path.TenantBookingsViewings}
                    element={
                        <ProtectedRoute>
                            <TenantBookingsViewings />
                        </ProtectedRoute>
                    }
                />

                <Route
                    path={Path.TenantMyEnquiries}
                    element={
                        <ProtectedRoute>
                            <TenantMyEnquiries />
                        </ProtectedRoute>
                    }
                />

                <Route
                    path={Path.Tenancies}
                    element={
                        <ProtectedRoute>
                            <Tenancies />
                        </ProtectedRoute>
                    }
                />

                <Route
                    path={Path.TenantNoticesRenewals}
                    element={
                        <ProtectedRoute>
                            <TenantNoticesRenewals />
                        </ProtectedRoute>
                    }
                />

                <Route
                    path={Path.TenantAgreements}
                    element={
                        <ProtectedRoute>
                            <TenantAgreements />
                        </ProtectedRoute>
                    }
                />

                <Route
                    path={Path.TenantRentReceipts}
                    element={
                        <ProtectedRoute>
                            <TenantRentReceipts />
                        </ProtectedRoute>
                    }
                />

                <Route
                    path={Path.TenantRentWallet}
                    element={
                        <ProtectedRoute>
                            <TenantRentWallet />
                        </ProtectedRoute>
                    }
                />

                {/* AGENTS */}

                <Route
                    path={Path.AgentJourney}
                    element={
                        <ProtectedRoute>
                            <AgentJourney />
                        </ProtectedRoute>
                    }
                />

                <Route
                    path={Path.AgentsAvailableListings}
                    element={
                        <ProtectedRoute>
                            <AgentsAvailableListings />
                        </ProtectedRoute>
                    }
                />

                <Route
                    path={Path.AgentsPropertyDetail}
                    element={
                        <ProtectedRoute>
                            <RolePropertyDetail />
                        </ProtectedRoute>
                    }
                />

                <Route
                    path={Path.AgentsMyAssignments}
                    element={
                        <ProtectedRoute>
                            <AgentsMyAssignments />
                        </ProtectedRoute>
                    }
                />

                <Route
                    path={Path.AgentsAgencyAgreements}
                    element={
                        <ProtectedRoute>
                            <AgentsAgencyAgreements />
                        </ProtectedRoute>
                    }
                />

                <Route
                    path={Path.AgentsEnquires}
                    element={
                        <ProtectedRoute>
                            <AgentsEnquires />
                        </ProtectedRoute>
                    }
                />

                <Route
                    path={Path.AgentsBookingInspections}
                    element={
                        <ProtectedRoute>
                            <AgentsBookingInspections />
                        </ProtectedRoute>
                    }
                />

                <Route
                    path={Path.AgentsDealRooms}
                    element={
                        <ProtectedRoute>
                            <AgentsDealRooms />
                        </ProtectedRoute>
                    }
                />

                <Route
                    path={Path.AgentsOffers}
                    element={
                        <ProtectedRoute>
                            <AgentsOffers />
                        </ProtectedRoute>
                    }
                />

                <Route
                    path={Path.AgentsCommissions}
                    element={
                        <ProtectedRoute>
                            <AgentsCommissions />
                        </ProtectedRoute>
                    }
                />

                <Route
                    path={Path.AgentsPayout}
                    element={
                        <ProtectedRoute>
                            <AgentsPayout />
                        </ProtectedRoute>
                    }
                />

                {/* LAWYER */}


                <Route
                    path={Path.LawyerJourney}
                    element={
                        <ProtectedRoute>
                            <LawyerJourney />
                        </ProtectedRoute>
                    }
                />

                <Route
                    path={Path.LawyerEngagement}
                    element={
                        <ProtectedRoute>
                            <LawyerEngagement />
                        </ProtectedRoute>
                    }
                />

                <Route
                    path={Path.LawyerDealRoom}
                    element={
                        <ProtectedRoute>
                            <LawyerDealRoom />
                        </ProtectedRoute>
                    }
                />

                <Route
                    path={Path.LawyerDueDiligence}
                    element={
                        <ProtectedRoute>
                            <LawyerDueDiligence />
                        </ProtectedRoute>
                    }
                />

                <Route
                    path={Path.LawyerPropertySearch}
                    element={
                        <ProtectedRoute>
                            <LawyerPropertySearch />
                        </ProtectedRoute>
                    }
                />

                <Route
                    path={Path.LawyerNegotiations}
                    element={
                        <ProtectedRoute>
                            <LawyerNegotiations />
                        </ProtectedRoute>
                    }
                />

                <Route
                    path={Path.LawyerContractsOfSales}
                    element={
                        <ProtectedRoute>
                            <LawyerContractsOfSales />
                        </ProtectedRoute>
                    }
                />

                <Route
                    path={Path.LawyerTenancyAgreement}
                    element={
                        <ProtectedRoute>
                            <LawyerTenancyAgreement />
                        </ProtectedRoute>
                    }
                />

                <Route
                    path={Path.LawyerDigitalDeeds}
                    element={
                        <ProtectedRoute>
                            <LawyerDigitalDeeds />
                        </ProtectedRoute>
                    }
                />

                <Route
                    path={Path.LawyerMyDocuments}
                    element={
                        <ProtectedRoute>
                            <LawyerMyDocuments />
                        </ProtectedRoute>
                    }
                />


                {/* VALUER */}

                <Route
                    path={Path.ValuerJourney}
                    element={
                        <ProtectedRoute>
                            <ValuerJourney />
                        </ProtectedRoute>
                    }
                />

                <Route
                    path={Path.ValuerAssignedValuation}
                    element={
                        <ProtectedRoute>
                            <ValuerAssignedValuation />
                        </ProtectedRoute>
                    }
                />

                <Route
                    path={Path.ValuerValuationReports}
                    element={
                        <ProtectedRoute>
                            <ValuerValuationReports />
                        </ProtectedRoute>
                    }
                />

                <Route
                    path={Path.ValuerDealRoomDocuments}
                    element={
                        <ProtectedRoute>
                            <ValuerDealRoomDocuments />
                        </ProtectedRoute>
                    }
                />




                {/* <Route path={Path.UserDashboard} element={<UserDashboard />} /> */}

                {/* ADMIN ROUTE */}
                <Route
                    path={Path.AdminDashboard}
                    element={
                        <AdminProtectedRoute>
                            <AdminDashboard />
                        </AdminProtectedRoute>
                    }
                />

                <Route
                    path={Path.AdminProperty}
                    element={
                        <AdminProtectedRoute>
                            <AdminProperty />
                        </AdminProtectedRoute>
                    }
                />

                <Route
                    path={Path.AdminPropertyDetail}
                    element={
                        <AdminProtectedRoute>
                            <AdminPropertyDetail />
                        </AdminProtectedRoute>
                    }
                />

                <Route
                    path={Path.AdminUsers}
                    element={
                        <AdminProtectedRoute>
                            <AdminUsers />
                        </AdminProtectedRoute>
                    }
                />

                <Route
                    path={Path.AdminSetting}
                    element={
                        <AdminProtectedRoute>
                            <AdminSetting />
                        </AdminProtectedRoute>
                    }
                />

                <Route
                    path={Path.AdminKycStatus}
                    element={
                        <AdminProtectedRoute>
                            <AdminKycStatus />
                        </AdminProtectedRoute>
                    }
                />

                <Route
                    path={Path.AdminDealRoom}
                    element={
                        <AdminProtectedRoute>
                            <AdminDealRoom />
                        </AdminProtectedRoute>
                    }
                />

                <Route
                    path={Path.AdminDealRoomDetail}
                    element={
                        <AdminProtectedRoute>
                            <AdminDealRoomDetail />
                        </AdminProtectedRoute>
                    }
                />

                <Route
                    path={Path.WaitingList}
                    element={
                        <AdminProtectedRoute>
                            <WaitingList />
                        </AdminProtectedRoute>
                    }
                />

                <Route
                    path={Path.AdminBookings}
                    element={
                        <AdminProtectedRoute>
                            <AdminBookings />
                        </AdminProtectedRoute>
                    }
                />

                <Route
                    path={Path.AdminNotifications}
                    element={
                        <AdminProtectedRoute>
                            <AdminNotifications />
                        </AdminProtectedRoute>
                    }
                />

                <Route
                    path="/admin/*"
                    element={
                        <AdminProtectedRoute>
                            <AdminNotFound />
                        </AdminProtectedRoute>
                    }
                />

                <Route
                    path="/user/*"
                    element={
                        <ProtectedRoute>
                            <DashboardNotFound />
                        </ProtectedRoute>
                    }
                />

                <Route path="*" element={<NotFound />} />
            </Routes>
        </Suspense>
    )

}

export default RouterConfig;